import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { SistemaPension } from '@shared/models';
import { ResponseWrapper } from '@shared';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_SISTEMA_PENSION = '/sistema-pension';

@Injectable({
  providedIn: 'root',
})
export class SistemaPensionService {
  private readonly API_URL_SISTEMA_PENSION = API_URL + ENDPOINT_SISTEMA_PENSION;
  private http = inject(HttpClient);

  listarSistemaPension(): Observable<SistemaPension[]> {
    return this.http.get<ResponseWrapper<SistemaPension[]>>(this.API_URL_SISTEMA_PENSION).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }
}
